import { FC } from "react";
import { Tooltip, Typography } from "@mui/material";
import numeral from "numeral";
import { metricsUnit } from "../utils/constants";
import { MetricType } from "@/components/pages/live-usage-mgmt/components/resource-card/resource-card-content/resource-card-data/resource-card-grid/resouce-card-data-grid/cells/metrics-cells/utils/types";

interface ResourceMetricsAggregationProps {
  value?: number | null;
  type: MetricType;
}

export const ResourceMetricsAggregation: FC<
  ResourceMetricsAggregationProps
> = ({ value, type }) => {
  const formattedPoint = formatMaxPoint(type, value);

  const typography = (
    <Typography
      variant="caption"
      color="text.secondary"
      fontSize={10}
      width={50}
      textTransform="uppercase"
      textAlign="right"
    >
      {formattedPoint ?? "N/A"}
      {!!value && metricsUnit[type]}
    </Typography>
  );

  if (value && formattedPoint !== `${value}`) {
    const prefix = getTooltipPrefix(type);
    const tooltipTitle = `${prefix}${numeral(value).format("0,0.[00]")} ${
      metricsUnit[type]
    }`;

    return (
      <Tooltip title={tooltipTitle} arrow placement="left">
        {typography}
      </Tooltip>
    );
  }

  return typography;
};

const getTooltipPrefix = (metricType: MetricType) => {
  if (metricType === "compute") {
    return "CPU Max: ";
  }
  if (metricType === "memory_used") {
    return "Memory Max: ";
  }
  return "";
};

const formatMaxPoint = (type: MetricType, point?: number | null) => {
  if (point === null) {
    return null;
  }

  if (type === "compute") {
    return point;
  }

  return numeral(point).format("0.[00]a");
};
